import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const footerLinks: { label: string; path: string }[] = [
    { label: t('nav.home'), path: '/' },
    { label: t('nav.platform'), path: '/plataforma' },
    { label: t('nav.autonomous'), path: '/agentes-autonomos' },
    { label: t('nav.connectors'), path: '/conectores' },
    { label: t('nav.demo'), path: '/demo' },
    { label: t('nav.security'), path: '/seguridad' },
    { label: t('nav.pricing'), path: '/precios' },
    { label: t('nav.partners'), path: '/partners' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#0F172A',
        color: 'white',
        py: 6,
        mt: 0,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
            gap: 6,
            mb: 6,
          }}
        >
          <Box>
            <Typography variant="h6" component="h2" gutterBottom sx={{ fontWeight: 700 }}>
              {t('footer.navigation')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }} component="nav" aria-label={t('footer.navigation')}>
              {footerLinks.map((link) => (
                <Typography
                  key={link.path}
                  component={RouterLink}
                  to={link.path}
                  sx={{
                    color: '#94A3B8',
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                    '&:hover': {
                      color: 'white',
                      transition: 'color 0.3s ease',
                    },
                  }}
                >
                  {link.label}
                </Typography>
              ))}
            </Box>
          </Box>

          <Box>
            <Typography variant="h6" component="h2" gutterBottom sx={{ fontWeight: 700 }}>
              {t('footer.company')}
            </Typography>
            <Typography sx={{ color: '#94A3B8', mb: 2, fontSize: '0.9rem' }}>
              {t('footer.tagline')}
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3, fontWeight: 700 }}>
              {t('footer.legal')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography
                component="a"
                href="/privacy.html"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#94A3B8',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  '&:hover': { color: 'white', transition: 'color 0.3s ease' },
                }}
              >
                {t('footer.privacyPolicy')}
              </Typography>
              <Typography
                component="a"
                href="/terms.html"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#94A3B8',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  '&:hover': { color: 'white', transition: 'color 0.3s ease' },
                }}
              >
                {t('footer.termsOfService')}
              </Typography>
              <Typography
                component="a"
                href="mailto:info@waiworking.com"
                sx={{
                  color: '#94A3B8',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  '&:hover': { color: 'white', transition: 'color 0.3s ease' },
                }}
              >
                {t('footer.contact')}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            mt: 4,
            pt: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
            {t('footer.copyright')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
